import { faHome, faPhoneAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form, Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import * as Yup from "yup";
import { contact } from "../../actions/contactAction";
import { getPersonalInformation } from "../../actions/profileAction";
import BreadCrumb from "../../components/Breadcrumb";
import FormikControl from "../../components/WraapperComponent/FormikControl";
import { getUserDetail } from "../../utils/helper";

const Contact = () => {
  const dispatch = useDispatch();
  const ref = useRef();
  const userInfo = useSelector((state) => state.profile.userInfo);
  const isUser = useLocation().pathname == "/app/contact";
  const [initialValues, setInitilaValues] = useState({
    name: isUser
      ? getUserDetail()?.firstName + " " + getUserDetail()?.lastName
      : "",
    email: "",
    reason: "",
    message: "",
  });

  const validationSchema = Yup.object({
    name: Yup.string().required("This field is required"),
    email: Yup.string().email().required("This field is required"),
    reason: Yup.string().required("This field is required"),
    message: Yup.string().required("This field is required"),
  });

  const onSubmit = (values) => {
    const params = {
      name: values.name,
      email: values.email,
      reason: values.reason,
      message: values.message,
      action: "contact",
      new_user: isUser ? "false" : "true",
    };
    dispatch(
      contact({ params }, () => {
        ref.current.resetForm();
      })
    );
  };

  const reasonsForContact = [
    { key: "Select Reason for contact", value: "" },
    { key: "Software / Tech Support", value: "Software/ Tech Support" },
    { key: "Pharmacy", value: "Pharmacy" },
  ];

  useEffect(() => {
    isUser && dispatch(getPersonalInformation());
  }, []);

  useEffect(() => {
    userInfo && ref.current.setFieldValue("email", userInfo.email);
  }, [userInfo]);

  return (
    <div className="contact-page">
      <BreadCrumb pageName="Contact" />
      <div className="row">
        <div className="col-sm-6">
          <h3 className="page-title">Contact</h3>
          <p className="page-desc">Send your message to us.</p>
          <div className="contact-form">
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
              innerRef={ref}
            >
              {(formik) => {
                return (
                  <Form>
                    {!isUser && (
                      <>
                        <FormikControl
                          control="forminput"
                          type="text"
                          label="* Name"
                          name="name"
                          handleBlur={formik.handleBlur}
                          hasError={formik.errors.name && formik.touched.name}
                        />
                        <FormikControl
                          control="forminput"
                          type="text"
                          label="* email"
                          name="email"
                          handleBlur={formik.handleBlur}
                          hasError={formik.errors.email && formik.touched.email}
                        />
                      </>
                    )}
                    <FormikControl
                      control="dropdown"
                      label="* Reason for contacting us"
                      name="reason"
                      handleBlur={formik.handleBlur}
                      hasError={formik.errors.reason && formik.touched.reason}
                      options={reasonsForContact}
                    />
                    <FormikControl
                      control="textarea"
                      label="* your message"
                      name="message"
                      rows="6"
                      handleBlur={formik.handleBlur}
                      hasError={formik.errors.message && formik.touched.message}
                    />

                    <div className="submit-section">
                      <button className="btn-orange" type="submit">
                        Send
                      </button>
                    </div>
                  </Form>
                );
              }}
            </Formik>
          </div>
        </div>
        <div className="col-sm-6">
          <div className="box">
            <h5>
              <span>MyHerbPharm</span>
            </h5>
            <p className="contact-info">
              <FontAwesomeIcon icon={faHome} />
              418 Walnut Ave, San Diego, CA 92103{" "}
            </p>
            <p className="contact-info">
              <FontAwesomeIcon icon={faPhoneAlt} /> 619-501-7603
            </p>
          </div>
          <div className="box">
            <h5>
              <span>Software Sales</span>
            </h5>

            <p className="contact-info">
              <FontAwesomeIcon icon={faPhoneAlt} /> 619-800-1875
            </p>
          </div>
          <div className="box">
            <h5>
              <span>Pharmacy</span>
            </h5>

            <p className="contact-info">
              <FontAwesomeIcon icon={faPhoneAlt} /> 619-501-7603
            </p>
          </div>
          <div className="box">
            <iframe
              title="map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3355.9044230958543!2d-117.16328468491436!3d32.74172849309125!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80d954c5f1cf6a59%3A0x324929d25b378e5e!2s418+Walnut+Ave%2C+San+Diego%2C+CA+92103!5e0!3m2!1sen!2sus!4v1524094388372"
              allowFullScreen
              frameBorder="0"
            ></iframe>
          </div>
          <div className="box">
            <h5>
              <span>Pharmacy Hours</span>
            </h5>
            <p>Monday-Friday 9am-5pm</p>
          </div>
          <div className="box">
            <h5>
              <span>Parking</span>
            </h5>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
